export default __webpack_public_path__ + "static/media/auchi-terminal.6b475112.png";